(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    // Desktop vertical gallery: one wheel/trackpad GESTURE over the photos moves exactly one photo
  // (plain scroll-snap needs several wheel notches to cross the snap threshold). At the first / last
  // photo the wheel is released so the page keeps scrolling. Touch and mobile are untouched.
  //
  // Trackpads send a stream of small deltas (tiny, ramping up, then an inertia tail that decays for
  // ~1-2 s). The handler ACCUMULATES delta until a threshold is reached, navigates once, then swallows
  // the rest of THAT gesture (inertia included). The inertia tail only decays, so a delta that starts
  // RISING again (or a direction change, or a pause) is a NEW swipe and is accepted right away once
  // the short cooldown is over, instead of waiting for the tail to die out.
  (() => {
    if (window.__productGalleryWheel) return;
    window.__productGalleryWheel = true;

    const desktop = window.matchMedia('(min-width: 750px)');
    const THRESHOLD = 45; // px of accumulated scroll that count as "go to the next photo"
    const COOLDOWN = 380; // ms after navigating during which nothing can navigate again
    const QUIET = 140; // ms without wheel events = the previous gesture is over
    const RISE_RATIO = 1.15; // a delta this much bigger than the previous one counts as "rising"
    const RISE_MIN = 4; // ...but only when it is at least this big (ignores sub-pixel noise)

    let accumulated = 0;
    let lastEventAt = 0;
    let lastAbs = 0;
    let lastSign = 0;
    let rises = 0;
    let cooldownUntil = 0;
    let locked = false; // true after a navigation, until a new swipe is detected

    document.addEventListener(
      'wheel',
      (event) => {
        if (!desktop.matches || event.ctrlKey || Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

        const gallery =
          event.target instanceof Element &&
          event.target.closest('.product-information__media media-gallery[data-presentation="carousel"]');
        if (!gallery) return;

        const slideshow = gallery.querySelector('slideshow-component');
        if (!slideshow || !slideshow.slides || slideshow.slides.length < 2) return;

        const now = performance.now();
        const gapSinceLast = now - lastEventAt;
        lastEventAt = now;

        const abs = Math.abs(event.deltaY);
        const sign = Math.sign(event.deltaY);
        if (abs >= RISE_MIN && abs > lastAbs * RISE_RATIO) rises += 1;
        else if (abs <= lastAbs) rises = 0;
        const reversed = lastSign !== 0 && sign !== lastSign;
        lastAbs = abs;
        lastSign = sign;

        if (locked) {
          // Cooldown: always swallow. Afterwards, only a pause, a reversal or a rising delta (two in a
          // row, so a stray +1 in the tail doesn't count) starts a new gesture; the inertia tail doesn't.
          const newGesture = gapSinceLast >= QUIET || reversed || rises >= 2;
          if (now < cooldownUntil || !newGesture) {
            event.preventDefault();
            accumulated = 0;
            return;
          }
          locked = false;
          accumulated = 0;
        }

        const goingDown = event.deltaY > 0;

        // At the first/last photo, scrolling further out hands over to the page.
        if ((goingDown && slideshow.atEnd) || (!goingDown && slideshow.atStart)) {
          accumulated = 0;
          return;
        }

        event.preventDefault();

        // New gesture or direction change: start counting again.
        if (gapSinceLast > QUIET || Math.sign(accumulated) !== sign) accumulated = 0;
        accumulated += event.deltaY;

        if (Math.abs(accumulated) < THRESHOLD) return;

        accumulated = 0;
        locked = true;
        rises = 0;
        cooldownUntil = now + COOLDOWN;
        if (goingDown) slideshow.next();
        else slideshow.previous();
      },
      { passive: false }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
